

// ******************************* resoudre le probléme de l'affichage de l'evaluation *************************************
import React, { useEffect, useState } from "react";
import courseService from "../../services/course.service";
import {
  Layout,
  Typography,
  Steps,
  Button,
  Divider,
  Collapse,
  List,
  Tabs,
  Input,
  Avatar,
  Card,
  Alert,
  Spin,
} from "antd";
import {
  PaperClipOutlined,
  ReadOutlined,
  FileDoneOutlined,
  TrophyOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

import QuizzesSubject from "./QuizzesSubject";
import TrainingForm from "./TrainingViewer";
import QuizPreviewComponent from "./QuizPreviewComponent";



const { Sider, Content } = Layout;
const { Step } = Steps;
const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

const footerElements = [
  { key: "train", label: "📘 Entraînez-vous", icon: <FileDoneOutlined />, color: "#1890ff" },
  { key: "eval", label: "📊 Évaluation", icon: <BarChartOutlined />, color: "#52c41a" },
  { key: "badge", label: "🏆 Badge", icon: <TrophyOutlined />, color: "#8c8c8c" },
  { key: "certif", label: "✅ Certificat de réussite", icon: <CheckCircleOutlined />, color: "#002766" },
];

const getQuizzes = (subject) => {
  if (subject?.quizzes?.length > 0) return subject.quizzes;
  if (subject?.children?.length > 0) {
    return subject.children.flatMap(child => child.quizzes || []);
  }
  return [];
};
const hasQuizzes = (subject) => getQuizzes(subject).length > 0;

// const flattenSubjects = (structure) => {
//   const flat = [];
//   structure.forEach((chapter) => {
//     chapter.subjects.forEach((subject) => {
//       flat.push(subject);
//     });
//   });
//   return flat;
// };

const flattenSubjects = (structure) => {
  const seen = new Set();
  const flat = [];

  structure.forEach((chapter) => {
    chapter.subjects.forEach((subject) => {
      const key = `${subject.id}-${subject.title}`;
      if (!seen.has(key)) {
        flat.push(subject);
        seen.add(key);
      }

      (subject.children || []).forEach((child) => {
        const childKey = `${child.id}-${child.title}`;
        if (!seen.has(childKey)) {
          flat.push(child);
          seen.add(childKey);
        }
      });
    });
  });

  return flat;
};


const CourseFullViewer = ({ courseId }) => {
  const [activeTab, setActiveTab] = useState("content");
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [readItems, setReadItems] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [viewMode, setViewMode] = useState("content");
  const [footerView, setFooterView] = useState(null);
  const [commentInput, setCommentInput] = useState("");
  const [courseStructure, setCourseStructure] = useState([]);
  const [flatList, setFlatList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quizResults, setQuizResults] = useState({});
  const [courseQuizzes, setCourseQuizzes] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    const fetchCourseQuizzes = async () => {
      try {
        const result = await courseService.getquizzes_of_cours(courseId);
        setCourseQuizzes(result);
      } catch (err) {
        console.error("Erreur lors du chargement des quizzes du cours :", err);
      }
    };

    if (courseId) fetchCourseQuizzes();
  }, [courseId]);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [selectedSubject]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await courseService.getCourseStructure(courseId);
        const groups = data.groups || [];
        setCourseStructure(groups);
        setFlatList(flattenSubjects(groups));

        // ✅ Auto-sélection du premier sujet ou sous-sujet
        if (groups.length > 0) {
          const firstGroup = groups[0];
          const firstSubject = firstGroup.subjects[0];

          if (firstSubject?.children?.length > 0) {
            setSelectedSubject(firstSubject.children[0]);
            setReadItems([firstSubject.children[0].title]);
          } else {
            setSelectedSubject(firstSubject);
            setReadItems([firstSubject.title]);
          }

          setViewMode("content");
          setCurrentStep(0);
        }
      } catch (error) {
        console.error("Erreur de chargement :", error);
      } finally {
        setLoading(false);
      }
    };

    if (courseId) fetchData();
  }, [courseId]);



  // const handleMarkAsRead = (arg) => {
  //   let subject, index;

  //   if (typeof arg === 'number') {
  //     index = arg;
  //     subject = flatList[index];
  //   } else {
  //     subject = arg;
  //     index = flatList.findIndex(s => s.id === subject.id);
  //   }

  //   if (!subject) return;

  //   let cleanSubject = { ...subject };

  //   if (subject.children?.length === 1 && subject.children[0].id === subject.id) {
  //     cleanSubject = {
  //       ...subject.children[0],
  //       title: subject.title,
  //       content: subject.content,
  //       comments: subject.comments,
  //     };
  //   }

  //   setSelectedSubject({
  //     ...cleanSubject,
  //     attachments: cleanSubject.attachments?.length ? cleanSubject.attachments : [],
  //     resources: cleanSubject.resources?.length ? cleanSubject.resources : [],
  //   });

  //   setSelectedIndex(index);
  //   setFooterView(null);

  //   if (!readItems.includes(cleanSubject.title)) {
  //     setReadItems((prev) => [...prev, cleanSubject.title]);
  //   }

  //   setViewMode("content");
  // };

  const handleMarkAsRead = (arg) => {
    let subject, index;

    if (typeof arg === 'number') {
      index = arg;
      subject = flatList[index];
    } else {
      subject = arg;
      index = flatList.findIndex(s => s.id === subject.id);
    }

    if (!subject) return;

    let cleanSubject = { ...subject };

    if (subject.children?.length === 1 && subject.children[0].id === subject.id) {
      cleanSubject = {
        ...subject.children[0],
        title: subject.title,
        content: subject.content,
        comments: subject.comments,
      };
    }

    setSelectedSubject({
      ...cleanSubject,
      attachments: cleanSubject.attachments?.length ? cleanSubject.attachments : [],
      resources: cleanSubject.resources?.length ? cleanSubject.resources : [],
      comments: cleanSubject.comments || [], // ✅ ajoute ceci si ce n’est pas garanti

    });

    // ✅ Met à jour le currentStep selon la position du sujet dans les chapitres
    const stepIndex = courseStructure.findIndex(chapter =>
      chapter.subjects.some(sub =>
        sub.id === cleanSubject.id ||
        (sub.children || []).some(child => child.id === cleanSubject.id)
      )
    );
    setCurrentStep(stepIndex);

    setSelectedIndex(index);
    setFooterView(null);

    if (!readItems.includes(cleanSubject.title)) {
      setReadItems((prev) => [...prev, cleanSubject.title]);
    }

    setViewMode("content");
  };


  const getQuizResultIcon = (subject) => {
    const result = quizResults[subject.id];
    console.log("🔍 Vérif icône quiz pour sujet ID:", subject.id, "=>", result);

    if (result === true) return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
    if (result === false) return <CloseCircleOutlined style={{ color: '#f5222d' }} />;
    return <CheckCircleOutlined style={{ color: '#d9d9d9' }} />;
  };


  // const handleQuizSubmit = (subjectId, isCorrect) => {
  //   setQuizResults(prev => ({ ...prev, [subjectId]: isCorrect }));
  // };

  const handleQuizSubmit = (subjectId, isCorrect) => {
    console.log("🧠 Quiz terminé pour sujet:", subjectId, "=>", isCorrect);
    setQuizResults(prev => ({ ...prev, [subjectId]: isCorrect }));
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider width={380} theme="light" style={{ padding: "1rem", overflowY: "auto" }}>
        <Title level={5}>📘 Sommaire du cours</Title>

        {loading ? (
          <div style={{ textAlign: "center", marginTop: 50 }}>
            <Spin tip="Chargement du sommaire..." />
          </div>
        ) : (
          <Steps direction="vertical" current={currentStep}>
            {courseStructure.map((chapter, chapterIndex) => (
              <Step
                key={chapterIndex}
                title={<strong>{chapter.title}</strong>}
                description={
                  <div>
                    {chapter.subjects.map((subject, subjectIndex) => {
                      const children = subject.children || [];
                      if (children.length > 0) {
                        return (
                          <Collapse key={subjectIndex} bordered={false} size="small" style={{ marginBottom: 8 }}>
                            <Panel header={subject.title} key="panel">
                              {children.map((sub, subIndex) => {
                                const isActive = selectedSubject?.title === sub.title;
                                const isRead = readItems.includes(sub.title);
                                return (
                                  <div key={subIndex} style={{ marginBottom: 6, paddingLeft: 10 }}>
                                    <Button
                                      type="link"
                                      onClick={() => handleMarkAsRead(sub)}
                                      style={{
                                        padding: 0,
                                        fontWeight: isActive ? "bold" : "normal",
                                        color: isActive ? "#1890ff" : "inherit",
                                      }}
                                    >
                                      ↳ {sub.title} {isRead && <span style={{ marginLeft: 6, color: "#52c41a" }}>✅</span>}
                                    </Button>

                                    {(hasQuizzes(sub) || sub.hasAttachments || sub.hasResource) && (
                                      <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: 4 }}>
                                        {hasQuizzes(sub) && (
                                          <Button
                                            size="small"
                                            type="default"
                                            style={{
                                              backgroundColor: "#fffbe6",
                                              borderColor: "#faad14",
                                              color: "#fa8c16",
                                              fontWeight: 500,
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 6,
                                            }}
                                            icon={getQuizResultIcon(sub)}  // ← ✅ Important
                                            onClick={() => {
                                              setSelectedSubject(sub);     // ← ✅ Important
                                              setViewMode("quiz");
                                            }}
                                          >
                                            Compris ? 🤔
                                          </Button>

                                        )}
                                        {/* {sub.hasAttachments && (
                                          <Button
                                            size="small"
                                            type="default"
                                            style={{ backgroundColor: "#f0f5ff", borderColor: "#2f54eb", color: "#2f54eb" }}
                                            icon={<PaperClipOutlined />}
                                            onClick={() => {
                                              setSelectedSubject(sub);
                                              setViewMode("attachments");
                                            }}
                                          >
                                            Pièces jointes
                                          </Button>
                                        )}
                                        {sub.hasResource && (
                                          <Button
                                            size="small"
                                            type="default"
                                            style={{ backgroundColor: "#e6fffb", borderColor: "#13c2c2", color: "#13c2c2" }}
                                            icon={<ReadOutlined />}
                                            onClick={() => {
                                              setSelectedSubject(sub);
                                              setViewMode("resources");
                                            }}
                                          >
                                            Ressources externes
                                          </Button>
                                        )} */}
                                        {(sub.attachments?.length > 0 || subject.attachments?.length > 0 || sub.hasAttachments) && (
                                          <Button
                                            size="small"
                                            type="default"
                                            style={{ backgroundColor: "#f0f5ff", borderColor: "#2f54eb", color: "#2f54eb" }}
                                            icon={<PaperClipOutlined />}
                                            onClick={() => {
                                              const mergedAttachments = [
                                                ...(sub.attachments || []),
                                                ...(subject.attachments || [])
                                              ];

                                              const uniqueAttachments = Array.from(
                                                new Map(mergedAttachments.map(item => [item.fileUrl, item])).values()
                                              );

                                              setSelectedSubject({
                                                ...sub,
                                                attachments: uniqueAttachments,
                                              });
                                              setViewMode("attachments");
                                            }}
                                          >
                                            Pièces jointes
                                          </Button>
                                        )}

                                        {(sub.resources?.length > 0 || subject.resources?.length > 0 || sub.hasResource) && (
                                          <Button
                                            size="small"
                                            type="default"
                                            style={{ backgroundColor: "#e6fffb", borderColor: "#13c2c2", color: "#13c2c2" }}
                                            icon={<ReadOutlined />}
                                            onClick={() => {
                                              const mergedResources = [
                                                ...(sub.resources || []),
                                                ...(subject.resources || [])
                                              ];

                                              const uniqueResources = Array.from(
                                                new Map(mergedResources.map(item => [item.content, item])).values()
                                              );

                                              setSelectedSubject({
                                                ...sub,
                                                resources: uniqueResources,
                                              });
                                              setViewMode("resources");
                                            }}
                                          >
                                            Ressources externes
                                          </Button>
                                        )}


                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </Panel>
                          </Collapse>
                        );
                      } else {
                        const isActive = selectedSubject?.title === subject.title;
                        const isRead = readItems.includes(subject.title);
                        return (
                          <div key={subjectIndex} style={{ marginBottom: 8 }}>
                            <Button
                              type="link"
                              onClick={() => {
                                handleMarkAsRead(subject);
                                setCurrentStep(chapterIndex);
                                setActiveTab("content");
                              }}
                              style={{
                                padding: 0,
                                fontWeight: isActive ? "bold" : "normal",
                                color: isActive ? "#1890ff" : "inherit",
                              }}
                            >
                              {subject.title} {isRead && <span style={{ marginLeft: 6, color: "#52c41a" }}>✅</span>}
                            </Button>

                            {/* {(hasQuizzes(subject) || subject.hasAttachments || subject.hasResource) && (
                              <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: 4 }}>
                                {hasQuizzes(subject) && (
                                  <Button
                                    size="small"
                                    type="default"
                                    icon={getQuizResultIcon(subject)}
                                    onClick={() => {
                                      setSelectedSubject(subject);
                                      setViewMode("quiz");
                                    }}
                                  >
                                    Faire le quiz 🤔
                                  </Button>
                                )}
                                {subject.hasAttachments && (
                                  <Button
                                    size="small"
                                    type="default"
                                    style={{ backgroundColor: "#f0f5ff", borderColor: "#2f54eb", color: "#2f54eb" }}
                                    icon={<PaperClipOutlined />}
                                    onClick={() => {
                                      setSelectedSubject(subject);
                                      setViewMode("attachments");
                                    }}
                                  >
                                    Pièces jointes
                                  </Button>
                                )}
                                {subject.hasResource && (
                                  <Button
                                    size="small"
                                    type="default"
                                    style={{ backgroundColor: "#e6fffb", borderColor: "#13c2c2", color: "#13c2c2" }}
                                    icon={<ReadOutlined />}
                                    onClick={() => {
                                      setSelectedSubject(subject);
                                      setViewMode("resources");
                                    }}
                                  >
                                    Ressources externes
                                  </Button>
                                )}
                              </div>
                            )} */}
                            {(hasQuizzes(subject) || subject.attachments?.length > 0 || subject.resources?.length > 0) && (
                              <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: 4 }}>
                                {hasQuizzes(subject) && (
                                  <Button
                                    size="small"
                                    type="default"
                                    icon={getQuizResultIcon(subject)}
                                    onClick={() => {
                                      setSelectedSubject(subject);
                                      setViewMode("quiz");
                                    }}
                                  >
                                    Faire le quiz 🤔
                                  </Button>
                                )}
                                {(subject.attachments?.length > 0 || subject.hasAttachments) && (
                                  <Button
                                    size="small"
                                    type="default"
                                    style={{ backgroundColor: "#f0f5ff", borderColor: "#2f54eb", color: "#2f54eb" }}
                                    icon={<PaperClipOutlined />}
                                    onClick={() => {
                                      setSelectedSubject(subject);
                                      setViewMode("attachments");
                                    }}
                                  >
                                    Pièces jointes
                                  </Button>
                                )}
                                {(subject.resources?.length > 0 || subject.hasResource) && (
                                  <Button
                                    size="small"
                                    type="default"
                                    style={{ backgroundColor: "#e6fffb", borderColor: "#13c2c2", color: "#13c2c2" }}
                                    icon={<ReadOutlined />}
                                    onClick={() => {
                                      setSelectedSubject(subject);
                                      setViewMode("resources");
                                    }}
                                  >
                                    Ressources externes
                                  </Button>
                                )}
                              </div>
                            )}

                          </div>
                        );
                      }
                    })}
                  </div>
                }
              />
            ))}
          </Steps>
        )}
        <div style={{ marginTop: 30 }}>
          <Divider />
          {footerElements.map((el, idx) => (
            <Button
              key={idx}
              type="default"
              size="large"
              icon={<span style={{ fontSize: 20 }}>{el.icon}</span>}
              block
              onClick={() => {
                setFooterView(el.key);
                setActiveTab("content");
                setSelectedSubject(null);
              }}
              style={{ marginBottom: 12 }}
            >
              {el.label}
            </Button>
          ))}
        </div>
      </Sider>

      <Layout>
        <Content style={{ padding: "2rem" }}>
          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <Tabs.TabPane tab="📄 Contenu" key="content" />
            <Tabs.TabPane tab="💬 Commentaires" key="comments" />
          </Tabs>

          <Title level={4}>
            📖 {selectedSubject ? `${selectedSubject.title} (ID: ${selectedSubject.id})` : "Aucun sujet sélectionné"}
          </Title>

          {/* 
          {viewMode === "content" && selectedSubject?.content && (
            <div style={{ marginTop: 24 }}>
              <Divider />
              <div
                dangerouslySetInnerHTML={{ __html: selectedSubject.content }}
                style={{ padding: 16, background: "#f9f9f9", borderRadius: 6 }}
              />
              <Divider />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  disabled={selectedIndex === 0}
                  onClick={() => handleMarkAsRead(selectedIndex - 1)}
                >
                  🔙 Précédent
                </Button>
                <Button
                  type="primary"
                  disabled={selectedIndex === flatList.length - 1}
                  onClick={() => handleMarkAsRead(selectedIndex + 1)}
                >
                  Suivant 🔜
                </Button>
              </div>
            </div>
          )} */}

          {/* {viewMode === "content" && selectedSubject?.content && ( */}
          {activeTab === "content" && viewMode === "content" && selectedSubject?.content && (

          <div style={{ marginTop: 24 }}>
              <Divider />
              <div
                dangerouslySetInnerHTML={{ __html: selectedSubject.content }}
                style={{ padding: 16, background: "#f9f9f9", borderRadius: 6 }}
              />
              <Divider />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  disabled={selectedIndex === 0}
                  onClick={() => handleMarkAsRead(selectedIndex - 1)}
                >
                  🔙 Précédent
                </Button>
                <Button
                  type="primary"
                  disabled={selectedIndex === flatList.length - 1}
                  onClick={() => handleMarkAsRead(selectedIndex + 1)}
                >
                  Suivant 🔜
                </Button>
              </div>
            </div>
          )}


          {viewMode === "attachments" && selectedSubject?.attachments?.length > 0 && (
            <>
              <Divider />
              <Title level={5}>📎 Pièces jointes</Title>
              <List
                size="small"
                bordered
                dataSource={selectedSubject.attachments}
                renderItem={(file) => (
                  <List.Item>
                    <a href={file.fileUrl} target="_blank" rel="noreferrer">{file.fileName}</a>
                  </List.Item>
                )}
              />
            </>
          )}

          {viewMode === "resources" && selectedSubject?.resources?.length > 0 && (
            <>
              <Divider />
              <Title level={5}>🔗 Ressources externes</Title>
              <List
                size="small"
                bordered
                dataSource={selectedSubject.resources}
                renderItem={(res) => (
                  <List.Item>
                    <div dangerouslySetInnerHTML={{ __html: res.content }} />
                  </List.Item>
                )}
              />
            </>
          )}

          {viewMode === "quiz" && selectedSubject && (
            <QuizzesSubject subject={selectedSubject} courseId={courseId} onSubmitResult={handleQuizSubmit} />
          )}
          {footerView === "train" && (
            <div style={{ marginTop: 24 }}>
              {/* <Title level={5}>📘 Espace d'entraînement</Title> */}
              <TrainingForm courseId={courseId} />
            </div>
          )}

          {footerView === "eval" && (
            <div style={{ marginTop: 24 }}>
              <Title level={5}>📊 Évaluation générale</Title>

              <Button onClick={() => setFooterView(null)} style={{ marginBottom: 16 }}>
                ← Retour au sommaire
              </Button>

              {(flatList?.some(subject => subject.quizzes?.length > 0) || courseQuizzes.length > 0) ? (
                <Collapse accordion>
                  {/* ✅ Quiz par sujet */}
                  {flatList
                    .flatMap(subject => subject.quizzes?.map(quiz => ({
                      ...quiz,
                      subjectTitle: subject.title,
                    })) || [])
                    .map((quiz) => (
                      <Collapse.Panel
                        key={`subject-${quiz.id}`}
                        header={
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <strong>{quiz.title}</strong>
                            <span style={{ fontStyle: "italic", fontSize: 12 }}>
                              ({quiz.subjectTitle})
                            </span>
                          </div>
                        }
                      >
                        <QuizPreviewComponent
                          quizId={quiz.id}
                          courseId={courseId}
                          attemptOnce={quiz.attemptOnce}
                        />
                      </Collapse.Panel>
                    ))}

                  {/* ✅ Quiz globaux liés au cours */}
                  {courseQuizzes.map((quiz) => (
                    <Collapse.Panel
                      key={`course-${quiz.id}`}
                      header={
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <strong>{quiz.title}</strong>
                          <span style={{ fontStyle: "italic", fontSize: 12 }}>
                            (Évaluation du cours)
                          </span>
                        </div>
                      }
                    >
                      <QuizPreviewComponent
                        quizId={quiz.id}
                        courseId={courseId}
                        attemptOnce={quiz.attemptOnce}
                      />
                    </Collapse.Panel>
                  ))}
                </Collapse>
              ) : (
                <Alert message="Aucun quiz d'évaluation disponible pour ce cours." type="info" />
              )}
            </div>
          )}

          {activeTab === "comments" && selectedSubject && (
            <>
              <Divider />
              <Title level={5}>💬 Commentaires pour "{selectedSubject.title}"</Title>

              {(selectedSubject.comments || []).map((c, idx) => (
                <Card key={idx} type="inner" title={c.author} style={{ marginBottom: 16 }}>
                  <div style={{ display: 'flex', gap: 12 }}>
                    <Avatar src={c.avatar} />
                    <div>
                      <p style={{ marginBottom: 4 }}>{c.content}</p>
                      <Typography.Text type="secondary">{c.date}</Typography.Text>
                    </div>
                  </div>
                </Card>
              ))}

              <Input.TextArea
                rows={3}
                value={commentInput}
                onChange={(e) => setCommentInput(e.target.value)}
                placeholder="Ajouter un commentaire..."
                style={{ marginTop: 16 }}
              />
              <Button
                type="primary"
                style={{ marginTop: 8 }}
                onClick={() => {
                  if (!commentInput.trim()) return;
                  const newComment = {
                    author: "Vous",
                    avatar: "https://i.pravatar.cc/150?u=you",
                    content: commentInput.trim(),
                    date: "À l’instant"
                  };

                  // ✅ Mise à jour de selectedSubject.comments
                  const updatedSubject = {
                    ...selectedSubject,
                    comments: [...(selectedSubject.comments || []), newComment]
                  };

                  setSelectedSubject(updatedSubject);
                  setCommentInput("");
                }}
              >
                Envoyer
              </Button>
            </>
          )}


        </Content>
      </Layout>
    </Layout>
  );
};

export default CourseFullViewer;
